import { useEffect, useState } from "react";

/**
 * Devuelve el valor solo cuando deja de cambiar durante `espera` ms.
 *
 * Sirve para no consultar al servidor en cada tecla: quien escribe una cedula
 * dispararia diez busquedas, y solo importa la ultima.
 *
 * @param {*} valor el que cambia con cada pulsacion.
 * @param {number} espera milisegundos de quietud antes de soltarlo.
 */
export const useDebounce = (valor, espera = 400) => {
  const [reposado, setReposado] = useState(valor);

  useEffect(() => {
    const temporizador = setTimeout(() => setReposado(valor), espera);
    // Cada cambio cancela el anterior: solo sobrevive el ultimo.
    return () => clearTimeout(temporizador);
  }, [valor, espera]);

  return reposado;
};
